import { Component, inject, Input } from '@angular/core';
import { DataLayerStore } from '../../../stores/data-layer/data-layer.state';
import { DataLayer } from '../../../models/data-layer';
import { ButtonModule } from 'primeng/button';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-year-select-button',
  standalone: true,
  imports: [ButtonModule, NgClass],
  templateUrl: './year-select-button.component.html',
  styleUrl: './year-select-button.component.scss',
})
export class YearSelectButtonComponent {
  dataLayerStore = inject(DataLayerStore);
  @Input() dataLayer!: DataLayer;
  @Input() disabled = false;

  /**
   * Toggles the selection state of a given data layer. If the data layer is
   * already selected, it will be removed from the selection. If it is not
   * selected, it will be added to the selection.
   *
   * @param {DataLayer} dataLayer - The data layer to select or deselect.
   * @return {void} Does not return a value.
   */
  selectDataLayer(dataLayer: DataLayer): void {
    const isInSelection = this.dataLayerStore.isInSelection(dataLayer);
    const selection = this.dataLayerStore.selection();

    if (isInSelection) {
      selection.splice(selection.indexOf(dataLayer), 1);
      this.dataLayerStore.updateSelection(selection);
    } else {
      selection.push(dataLayer);
      this.dataLayerStore.updateSelection(selection);
    }
  }
}
